import Icon from "@/components/library/Icon";
import type { IQRScannerProps } from "@/components/screens/Login/Types/LoginTypes";
import { faXmark } from "@/icons/solid-icons";
import { QRScannerStatus } from "@/types/login/QRScanner";
import { cn } from "@/utils/css";

const QRScanner = ({ vm }: IQRScannerProps) => {
  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: backdrop-click cancel is a mouse convenience; keyboard users dismiss via Esc (VM document listener) or the focused close button
    <div
      role="dialog"
      aria-modal="true"
      aria-label={vm.labels.title}
      onClick={vm.onCancel}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/80 px-6 py-8"
    >
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: stops backdrop-cancel bubbling for inside clicks; no keyboard action to mirror */}
      <div
        onClick={(event) => event.stopPropagation()}
        className="relative flex w-full max-w-md flex-col items-center"
      >
        <button
          ref={vm.closeRef}
          type="button"
          aria-label={vm.labels.closeAriaLabel}
          onClick={vm.onCancel}
          className={cn(
            "absolute top-3 right-3 z-10 flex h-9 w-9 items-center justify-center rounded-full",
            "bg-white text-dines-purple-darkest shadow-lg hover:bg-white/90",
            "focus:outline-none focus-visible:ring-2 focus-visible:ring-dines-green",
          )}
        >
          <Icon icon={faXmark} className="h-5 w-5" />
        </button>

        {vm.status === QRScannerStatus.Error ? (
          <p
            role="status"
            aria-live="polite"
            className="text-center text-sm text-white/80"
          >
            {vm.errorMessage}
          </p>
        ) : (
          <>
            <div className="relative aspect-square w-full overflow-hidden rounded-3xl bg-black">
              <video
                ref={vm.videoRef}
                muted
                playsInline
                className="h-full w-full object-cover"
              />
              <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                <div className="h-48 w-48 rounded-2xl border-2 border-white/70" />
              </div>
            </div>
            <p
              role="status"
              aria-live="polite"
              className="mt-4 mb-4 text-center text-sm text-white/80"
            >
              {vm.status === QRScannerStatus.Requesting
                ? vm.labels.requesting
                : vm.labels.prompt}
            </p>
          </>
        )}
      </div>
      <canvas ref={vm.canvasRef} className="hidden" />
    </div>
  );
};

export default QRScanner;
